export const COUNTRY_FACET = 'COUNTRY';
export const SCHOOL_FACET = 'SCHOOL_NAME';
export const STATE_FACET = 'SCHOOL_STATE';
export const DISCIPLINE_FACET = 'SECTION';
export const DEFAULT_COUNTRY_CODE = 'US';

export declare interface CreateCountry {
  code: string;
  description: string;
}

export enum FilterAction {
  ADD = 'ADD',
  CHANGE = 'CHANGE',
  CLEAR = 'CLEAR',
  CLEAR_ALL = 'CLEAR_ALL',
  CLEAR_AND_CHANGE = 'CLEAR_AND_CHANGE',
  REMOVE = 'REMOVE',
}
